import Content from '../../../../components/Section/Content';
import Box from '../../../../components/Section/Box';
import Icon from '../../../../components/Section/Icon';
import svg from '../../../../static/img/icon-open-menu.svg';
import { Categories, Actions, Labels } from '../../../../types/gtm';
import { useAuth } from '../../../../hooks/useAuth';
import Action from '../../../../components/Section/Action';

const BoxEditUser = () => {
  const { user } = useAuth();
  const title = 'Dados Pessoais';
  const describeTitle = 'Gerencie seus dados pessoais e de acesso';
  return (
    <Box title={title} describeTitle={describeTitle}>
      <Content>
        <Action
          onClick={() => {
            window.dataLayer.push({
              event: 'customEventUserInteraction',
              event_category: Categories.Home,
              event_action: Actions.ClickEditEmail,
              event_label: Labels.Home,
              bd_suser_code: user?.globoId,
            });
          }}
          to="/email/change"
          theme="link"
        >
          <p>Alterar e-mail</p>
          <Icon svg={svg} alt="icon-open-menu" />
        </Action>

        <hr aria-hidden />

        <Action
          onClick={() => {
            window.dataLayer.push({
              event: 'customEventUserInteraction',
              event_category: Categories.Home,
              event_action: Actions.ClickEditPassword,
              event_label: Labels.Home,
              bd_suser_code: user?.globoId,
            });
          }}
          to="/alterar-senha"
          theme="link"
        >
          <p>Alterar senha</p>
          <Icon svg={svg} alt="icon-open-menu" />
        </Action>
        <hr aria-hidden />
        <Action
          to="/alterar-dados"
          theme="link"
          onClick={() => {
            window.dataLayer.push({
              event: 'customEventUserInteraction',
              event_category: Categories.Home,
              event_action: Actions.ClickEditUser,
              event_label: Labels.Home,
              bd_suser_code: user?.globoId,
            });
          }}
        >
          <p>Editar dados pessoais</p>
          <Icon svg={svg} alt="icon-open-menu" />
        </Action>
      </Content>
    </Box>
  );
};

export default BoxEditUser;
